import React from "react"
import Container from "./Container"

const Panel = ({ filterConfig = [], onReset }) => {
  return <Container filterConfig={filterConfig} onReset={onReset} />
}

export default Panel
